import { ProductType } from '@/data/types/Product';
import { findProductAttribute } from './findProductAttribute';
import { ProductAvailabilityData } from '@/data/types/ProductAvailabilityData';

export const getAvailableProductSizes = (product?: ProductType, availability?: ProductAvailabilityData[]) => {
	if (!product || !availability) return [];

	const sizesMap = new Map(
		product?.items.map((item) => [
			item.id,
			findProductAttribute(item.attributes, 'Talla')?.value ?? '',
		])
	);

	return availability
		.filter((item) => item.status)
		.map((item) => sizesMap.get(item.productId ?? ''))
		.filter((size): size is string => Boolean(size));
};
